/**
 * quizJournee1Am.js — Quiz d'ancrage Permis AM · Journée 1 (Cyclomoteur)
 * 10 QCM pédagogiques rédigés à partir des sections du cours.
 * Format : { q, choices[4], answer (0-3), explain }
 */
export const quiz = {
  id: 'permis-am-j1',
  title: "Quiz d'ancrage · Journée 1 Cyclomoteur",
  color: '#dc2626',
  cours: '/cours/permis-am-journee-1',
  questions: [
    {
      q: "Quelle est la vitesse maximale autorisée d'un cyclomoteur de 50 cm³ bridé ?",
      choices: ['30 km/h', '45 km/h', '50 km/h', '80 km/h'],
      answer: 1,
      explain: "Un cyclomoteur 50 cm³ est bridé à 45 km/h par construction (norme européenne).",
    },
    {
      q: "L'équipement obligatoire pour conduire un cyclomoteur inclut :",
      choices: [
        'Casque uniquement',
        'Casque + gants CE',
        'Casque + gants + blouson renforcé',
        'Uniquement une veste réfléchissante',
      ],
      answer: 1,
      explain: "Le casque homologué et les gants CE sont OBLIGATOIRES. Le blouson est fortement recommandé mais pas obligatoire.",
    },
    {
      q: "Avant de démarrer, la vérification de la pression des pneus se fait :",
      choices: ["À chaud, après avoir roulé", "À froid, avant de rouler", "Peu importe le moment", "Uniquement chez le mécanicien"],
      answer: 1,
      explain: "La pression se vérifie toujours à froid pour obtenir une mesure fiable.",
    },
    {
      q: "Que signifie la position « regarder loin » sur un cyclomoteur ?",
      choices: [
        'Fixer sa roue avant',
        'Regarder juste devant le véhicule qui précède',
        'Anticiper 10 à 15 secondes devant',
        'Regarder uniquement les rétroviseurs',
      ],
      answer: 2,
      explain: "Regarder loin = anticiper 10-15 sec devant pour avoir le temps d'analyser et réagir.",
    },
    {
      q: "En intersection, la règle prioritaire à connaître par cœur est :",
      choices: [
        'Priorité au plus rapide',
        'Priorité à droite (sauf indication contraire)',
        'Priorité à celui qui tourne',
        'Toujours céder le passage',
      ],
      answer: 1,
      explain: "En France, la priorité à droite s'applique par défaut à toute intersection non signalisée.",
    },
    {
      q: "Le principal danger pour un cyclomotoriste débutant en agglomération est :",
      choices: [
        'La vitesse excessive',
        "Les portières de voitures stationnées qui s'ouvrent",
        'Les feux rouges',
        'Le vent',
      ],
      answer: 1,
      explain: "Les portières qui s'ouvrent sans que le conducteur ne regarde causent de nombreux accidents graves à 2 roues.",
    },
    {
      q: "Pour freiner efficacement en ligne droite, il faut :",
      choices: [
        'Utiliser uniquement le frein avant',
        'Utiliser uniquement le frein arrière',
        'Utiliser les deux freins simultanément et progressivement',
        'Serrer le frein arrière au maximum',
      ],
      answer: 2,
      explain: "Les deux freins ensemble et de manière progressive donnent la distance de freinage la plus courte sans perte d'adhérence.",
    },
    {
      q: "Quelle est la distance de sécurité minimale à respecter avec le véhicule qui précède ?",
      choices: ['1 seconde', '2 secondes', '5 secondes', '10 mètres fixes'],
      answer: 1,
      explain: "La règle des 2 secondes minimum s'applique. Sur route mouillée, doubler à 3-4 secondes.",
    },
    {
      q: "Qu'est-ce qu'un « angle mort » sur un cyclomoteur ?",
      choices: [
        "Une zone que l'on voit uniquement dans le rétro",
        "Une zone que l'on ne voit ni de face ni dans les rétros",
        'Un point aveugle du casque',
        "L'ombre d'un panneau",
      ],
      answer: 1,
      explain: "L'angle mort est la zone invisible sans tourner la tête. Un contrôle visuel direct est OBLIGATOIRE avant tout changement de direction.",
    },
    {
      q: "Si tu perds l'adhérence à l'arrière (le pneu glisse), la bonne réaction est :",
      choices: [
        'Freiner fort de l\'avant',
        'Continuer d\'accélérer',
        'Relâcher progressivement l\'accélérateur, regarder loin, garder les bras souples',
        'Se pencher davantage',
      ],
      answer: 2,
      explain: "Relâcher doucement, regarder loin dans la direction souhaitée, garder les bras souples permet à la moto de se stabiliser naturellement.",
    },
  ],
};

export default quiz;
